import * as types from './Push.types';

export const pushMessageReceived = (data) => ({
  type: types.PUSH_MESSAGE_RECEIVED,
  data,
});

export const pushMessageViewed = (id) => ({
  type: types.PUSH_MESSAGE_VIEWED,
  id,
});
